import React, {useEffect} from 'react'
import LogoPP from "../common/LogoPP";
import { injectIntl, intlShape } from "react-intl";
import PropTypes from "prop-types";
import { Button } from "cxa-components";
import messages from "components/messagesDescription";
import { loadConsentMessage, postGrantConsent } from "actions/loginActions";
import { useDispatch, useSelector } from "react-redux";

const GrantConsentPagePP = ({intl}) => {

    const consentMessage = useSelector(state => state.login.consentMessage);

    const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadConsentMessage())
  }, [])

  return (
    <div className="consent-wrapper">
    <div className="consent">
      <div className="o-wrapper-pp">
        <LogoPP width={240} />
        <article className="consent__card-pp">
          <section>
            <div
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({
                  id: consentMessage,
                  defaultMessage: consentMessage,
                }),
              }}
            />
          </section>
        </article>
        <div className='button-container-pp'>
          <Button primary className="consent__button-pp" onClick={() => dispatch(postGrantConsent())}>
            {intl.formatMessage(messages.consentTextDescription)}
          </Button>
          <Button to="/logout" secondary className="consent__button-pp">
            {intl.formatMessage(messages.logoutTextDescription)}
          </Button>
        </div>
      </div>
    </div>
  </div>
  )
}

GrantConsentPagePP.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl((GrantConsentPagePP));



// WEBPACK FOOTER //
// ./components/consent/GrantConsentPagePP.js